// extracted by mini-css-extract-plugin
export default {"faCircleNotchSpin":"Loading_faCircleNotchSpin__rjW4o","divLoading":"Loading_divLoading__pvbQm","pLoading":"Loading_pLoading__AhFtH"};